<template>
    <div class="pd20x flex1">
      <!-- View Modal -->
      <a-modal
        :title="viewModal.title"
        :visible="viewModal.visible"
        :confirm-loading="viewModal.confirmLoading"
        :footer="viewModal.record && viewModal.record.status === 0 ? null : undefined"
        @cancel="viewModal.visible = false"
        width="800px"
      >
        <a-form-model
          v-if="viewModal.record"
          ref="statusForm"
          :model="statusForm"
          :rules="statusRules"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 18 }"
        >
          <a-form-model-item label="科目">
            <span>{{ viewModal.record.subject_name || '--' }}</span>
          </a-form-model-item>
          
          <a-form-model-item label="试卷名称">
            <span>{{ viewModal.record.paper_name || '--' }}</span>
          </a-form-model-item>
          
          <a-form-model-item label="题目内容">
            <div v-html="viewModal.record.correction_detail || '--'"></div>
          </a-form-model-item>
          
          <a-form-model-item label="错误描述">
            <div v-html="viewModal.record.error_detail || '--'"></div>
          </a-form-model-item>
          
          <a-form-model-item label="当前状态">
            <a-tag :color="getStatusColor(viewModal.record.status)">
              {{ getStatusText(viewModal.record.status) }}
            </a-tag>
          </a-form-model-item>
          
          <a-form-model-item 
            v-if="viewModal.record.status === 0" 
            label="处理状态" 
            prop="status"
          >
            <a-select 
              v-model="statusForm.status" 
              style="width: 100%"
              placeholder="请选择处理结果"
            >
              <a-select-option :value="0">待处理</a-select-option>
              <a-select-option :value="1">已处理</a-select-option>
              <a-select-option :value="2">无需处理</a-select-option>
            </a-select>
          </a-form-model-item>
          
          <template v-if="viewModal.record.status !== 0 && false">
            <a-form-model-item label="处理人" prop="handler">
              {{ viewModal.record.handler || '--' }}
            </a-form-model-item>
            
            <a-form-model-item label="处理时间" prop="handled_at">
              {{ viewModal.record.handled_at || '--' }}
            </a-form-model-item>
            
            <a-form-model-item label="处理备注" prop="handle_remark">
              {{ viewModal.record.handle_remark || '--' }}
            </a-form-model-item>
          </template>
          
          <a-form-model-item 
            v-if="viewModal.record.status === 0" 
            :wrapper-col="{ span: 24 }"
            style="text-align: right;"
          >
            <a-button @click="viewModal.visible = false">取消</a-button>
            <a-button 
              type="primary" 
              @click="handleStatusSubmit"
              :loading="viewModal.confirmLoading"
              style="margin-left: 10px;"
            >
              提交
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <!-- Add/Edit Category Dialog -->
      <a-modal
        title="添加问题分类"
        :visible="categoryModal.visible"
        @ok="handleCategorySubmit"
        @cancel="categoryModal.visible = false"
      >
        <a-form :form="categoryForm">
          <a-form-item label="分类名称" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-input
              v-decorator="[
                'name',
                { rules: [{ required: true, message: '请输入分类名称' }] }
              ]"
              placeholder="请输入分类名称"
            />
          </a-form-item>
          <a-form-item label="分类描述" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-textarea
              v-decorator="['description']"
              placeholder="请输入分类描述（选填）"
              :rows="3"
            />
          </a-form-item>
        </a-form>
      </a-modal>
  
      <div class="contentBox h100pct ofA">
        <a-tabs v-model="activeTab" @change="handleTabChange">
          <a-tab-pane key="error" tab="试题纠错">
            <div class="filter" style="padding:10px 20px">
              <div class="flex">
                <!-- Subject Filter -->
                <div class="mr10px">
                    <a-input
                        v-model="searchParams.subject_name"
                        placeholder="搜索科目名称"
                        style="width: 200px"
                        allowClear
                    />
                </div>
    
                <!-- Paper ID Search -->
                <div class="mr10px">
                    <a-input
                    v-model="searchParams.paper_keyword"
                    placeholder="试卷名称"
                    style="width: 200px"
                    allowClear
                />
                </div>
    
                <!-- Category Filter -->
                <div class="mr10px">
                  <a-select
                    v-model="searchParams.category_id"
                    placeholder="选择问题分类"
                    style="width: 180px"
                    allowClear
                    @change="handleSearch"
                  >
                    <a-select-option
                      v-for="category in categoryList"
                      :key="category.id"
                      :value="category.id"
                    >
                      {{ category.name }}
                    </a-select-option>
                  </a-select>
                </div>
    
                <!-- Status Filter -->
                <div class="mr10px">
                  <a-select
                    v-model="searchParams.status"
                    placeholder="选择状态"
                    style="width: 120px"
                    allowClear
                    @change="handleSearch"
                  >
                    <a-select-option :value="0">待处理</a-select-option>
                    <a-select-option :value="1">已解决</a-select-option>
                    <a-select-option :value="2">无需处理</a-select-option>
                  </a-select>
                </div>
    
                <a-button type="primary" @click="handleSearch" class="mr10px">
                  搜索
                </a-button>
                <a-button @click="handleReset" class="mr10px">
                  重置
                </a-button>
                <a-button @click.stop="showAddCategory">
                    <a-icon type="plus" /> 添加纠错分类
                </a-button>
              </div>
            </div>
    
            <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="pagination"
              :loading="loading"
              :rowKey="'id'"
              @change="handleTableChange"
            >
              <template slot="category" slot-scope="text, record">
                {{ getCategoryName(record.category_id) }}
              </template>
    
              <template slot="status" slot-scope="text, record">
                <a-tag :color="getStatusColor(record.status)">
                  {{ getStatusText(record.status) }}
                </a-tag>
              </template>
    
              <template slot="action" slot-scope="text, record">
                <a-button type="link" size="small" @click="handleView(record)">
                  查看
                </a-button>
                <!-- 删除 -->
                <a-button type="link" size="small">
                    <a-popconfirm
                      title="确定删除?"
                      @confirm="handleDelete(record)"
                    >
                      <div class="z_tag">删除</div>
                  </a-popconfirm>
                </a-button>
              </template>
            </a-table>
          </a-tab-pane>
          <a-tab-pane key="vip" tab="vip题型纠错">
            <div class="filter" style="padding:10px 20px">
              <div class="flex">
                <!-- Subject Filter -->
                <div class="mr10px">
                    <a-input
                        v-model="search2Params.subject_name"
                        placeholder="搜索科目名称"
                        style="width: 200px"
                        allowClear
                    />
                </div>

                <!-- Status Filter -->
                <div class="mr10px">
                  <a-select
                    v-model="search2Params.status"
                    placeholder="选择状态"
                    style="width: 120px"
                    allowClear
                    @change="handleStatusChange"
                  >
                    <a-select-option :value="0">待处理</a-select-option>
                    <a-select-option :value="1">已解决</a-select-option>
                  </a-select>
                </div>
    
                <a-button type="primary" @click="handleVipSearch" class="mr10px">
                  搜索
                </a-button>
                <a-button @click="handleVipReset" class="mr10px">
                  重置
                </a-button>
              </div>
            </div>
            <a-table
              :columns="vipColumns"
              :data-source="vipDataSource"
              :pagination="vipPagination"
              :loading="vipLoading"
              :rowKey="'id'"
              @change="handleVipTableChange"
            >
              <template slot="vip_types" slot-scope="text, record">
                <div v-for="(item, index) in JSON.parse(record.question_list)" :key="index">
                  {{ item.title }}：{{ item.num }}题
                </div>
              </template>
              <template slot="vip_action" slot-scope="text, record">
                <a-button type="link" size="small" v-if="record.status === 0" @click="handleVipProcessed(record)">已处理</a-button>
                <a-button type="link" size="small">
                  <a-popconfirm title="确定删除?" @confirm="handleVipDelete(record)">
                    <div class="z_tag">删除</div>
                  </a-popconfirm>
                </a-button>
              </template>
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </template>
  
  <script>
  import { getErrorCorrections, updateErrorStatus, addErrorCategory, getErrorCategories, deleteErrorCorrection, getVipTypeCorrects, updateVipTypeCorrectStatus, delVipTypeCorrect } from '@/libs/api'
  export default {
    name: 'ErrorCorrections',
    data() {
      return {
        // Tabs
        activeTab: 'error',
        // Table
        loading: false,
        dataSource: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showQuickJumper: true,
        },
        // VIP Table
        vipLoading: false,
        vipDataSource: [],
        vipPagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showQuickJumper: true
        },
  
        // Search
        searchParams: {
            subject_name: undefined,
            paper_keyword: undefined,
            category_id: undefined,
            status: undefined
        },
  
        // Category Modal
        categoryModal: {
          visible: false,
          confirmLoading: false
        },
        categoryForm: this.$form.createForm(this),
  
        // View Modal
        viewModal: {
          visible: false,
          confirmLoading: false,
          title: '错题详情',
          record: null
        },
        statusForm: {
          status: 0
        },
        statusRules: {
          status: [
            { required: true, message: '请选择处理状态', trigger: 'change' }
          ]
        },
  
        // Data
        subjectList: [],
        categoryList: [],
        // VIP Search
        search2Params: {
            subject_name: undefined,
            status: undefined
        },
      }
    },
  
    computed: {
      columns() {
        return [
          {
            title: 'ID',
            dataIndex: 'id',
            width: 80
          },
          {
            title: '科目',
            dataIndex: 'subject_name'
          },
          {
            title: '试卷',
            dataIndex: 'paper_name'
          },
          {
            title: '问题分类',
            scopedSlots: { customRender: 'category' }
          },
          {
            title: '问题描述',
            dataIndex: 'error_detail',
            ellipsis: true
          },
          {
            title: '状态',
            scopedSlots: { customRender: 'status' },
            width: 100
          },
          {
            title: '提交时间',
            dataIndex: 'created_at',
            scopedSlots: { customRender: 'created_at' },
            width: 160
          },
          {
            title: '操作',
            key: 'action',
            width: 150,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
      vipColumns() {
        return [
          { title: 'ID', dataIndex: 'id', width: 80 },
          { title: '科目', dataIndex: 'subject_name' },
          { title: '提交题型', key: 'vip_types', scopedSlots: { customRender: 'vip_types' } },
          { title: '提交用户', dataIndex: 'submit_user', width: 160 },
          { title: '提交时间', dataIndex: 'created_at', width: 180 },
          { title: '操作', key: 'vip_action', width: 150, scopedSlots: { customRender: 'vip_action' } }
        ]
      }
    },
  
    created() {
      this.fetchData()
      this.fetchCategories()
      // 预加载VIP纠错列表
      this.fetchVipData()
    },
  
    methods: {
      handleTabChange(key){
        if (key === 'vip') {
          this.fetchVipData()
        } else {
          this.fetchData()
        }
      },
      fetchData() {
        const params = {
            page: this.pagination.current,
            limit: this.pagination.pageSize,
            ...this.searchParams
          }
          getErrorCorrections(params).then(res=>{
              this.dataSource = res.data
              this.pagination.total = res.total
            }).catch(error=>{
                this.loading = false
                console.log(error)
            })
      },
  
      fetchCategories() {
        getErrorCategories().then(res=>{
              this.categoryList = res
            },error=>{
                console.log(error)
            })
      },
  
      // VIP 列表
      fetchVipData(){
        this.vipLoading = true
        const params = {
          page: this.vipPagination.current,
          limit: this.vipPagination.pageSize,
          ...this.search2Params
        }
        getVipTypeCorrects(params).then(res=>{
          this.vipDataSource = res.data
          this.vipPagination.total = res.total
        }).catch(err=>{
          console.log(err)
        }).finally(()=>{
          this.vipLoading = false
        })
      },

      handleVipTableChange(pagination){
        this.vipPagination.current = pagination.current
        this.vipPagination.pageSize = pagination.pageSize
        this.fetchVipData()
      },

      handleVipProcessed(record){
        updateVipTypeCorrectStatus({ id: record.id, status: 1 }).then(()=>{
          this.$message.success('已标记为已处理')
          this.fetchVipData()
        }).catch(err=>{
          console.log(err)
        })
      },

      handleVipDelete(record){
        delVipTypeCorrect({ id: record.id }).then(()=>{
          this.$message.success('删除成功')
          this.fetchVipData()
        }).catch(err=>{
          console.log(err)
        })
      },

      // Handlers
      handleTableChange(pagination, filters, sorter) {
        this.pagination.current = pagination.current
        this.pagination.pageSize = pagination.pageSize
        this.fetchData()
      },
      
      handleSearch() {
        this.pagination.current = 1
        this.fetchData()
      },
      
      handleReset() {
        this.searchParams = {
          subject_name: undefined,
          paper_keyword: undefined,
          category_id: undefined,
          status: undefined
        }
        this.handleSearch()
      },
      handleStatusChange(e){
        this.searchParams.status = e
      },
      handleVipSearch() {
        this.vipPagination.current = 1
        this.fetchVipData()
      },
      
      handleVipReset() {
        this.search2Params = {
          subject_name: undefined,
          status: undefined
        }
        this.handleVipSearch()
      },
  
      showAddCategory() {
        this.categoryModal.visible = true
        this.$nextTick(() => {
          this.categoryForm.resetFields()
        })
      },
  
      async handleCategorySubmit() {
        try {
          const values = await this.categoryForm.validateFields()
          this.categoryModal.confirmLoading = true
          
          await addErrorCategory(values)
          this.categoryModal.visible = false
          this.fetchCategories()
        } catch (error) {
          console.error('添加分类失败:', error)
        } finally {
          this.categoryModal.confirmLoading = false
        }
      },
  
      handleView(record) {
        console.log(record)
        this.viewModal.record = { ...record };
        this.statusForm.status = record.status;
        this.viewModal.visible = true;
      },
      handleDelete(record) {
         deleteErrorCorrection({id:record.id}).then(res=>{
              this.$message.success('删除成功');
              this.fetchData(); // Refresh the table
            }).catch(error=>{
                console.log(error)
            })
      },
  
      async handleStatusSubmit() {
        try {
          await this.$refs.statusForm.validate();
          this.viewModal.confirmLoading = true;
          
          //todo 更新状态
          updateErrorStatus({id:this.viewModal.record.id,status:this.statusForm.status}).then(res=>{
            this.$message.success('处理状态已更新');
            this.viewModal.visible = false;
            this.fetchData(); // Refresh the table
          }).catch(error=>{
              console.log(error)
          })
          
        } catch (error) {
          console.error('更新状态失败:', error);
          this.$message.error('更新状态失败');
        } finally {
          this.viewModal.confirmLoading = false;
        }
      },
  
      getCategoryName(categoryId) {
        const category = this.categoryList.find(item => item.id === categoryId)
        return category ? category.name : '未知分类'
      },
  
      getStatusText(status) {
        const statusMap = {
          0: '待处理',
          1: '已解决',
          2: '无需处理'
        }
        return statusMap[status] || '未知状态'
      },
  
      getStatusColor(status) {
        const colorMap = {
          0: 'orange',
          1: 'blue',
          2: 'green'
        }
        return colorMap[status] || 'default'
      }
  }
}
</script>

<style scoped>
.question-content,
.error-description {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.5;
}

.ant-form-item {
  margin-bottom: 12px;
}

.action-btns {
  margin-bottom: 16px;
}

.filter {
  margin-bottom: 16px;
  .flex{
    display: flex;
  }
}
</style>